import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=028aacfa&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=js&"
export * from "./MainMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=028aacfa&prod&scoped=true&lang=css&"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=028aacfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aacfa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconBase: require('/home/vsts/work/1/s/components/IconBase.vue').default})
